import { format, isToday, isYesterday, differenceInDays, startOfDay, parseISO } from 'date-fns';

export function getMessageDate(message) {
  const raw = message?.created_at ?? message?.timestamp ?? null;
  if (!raw) return null;
  try {
    return typeof raw === 'string' ? parseISO(raw) : new Date(raw);
  } catch {
    return null;
  }
}

export function formatRelativeDay(date) {
  if (!date) return '';
  if (isToday(date)) return 'Today';
  if (isYesterday(date)) return 'Yesterday';
  const diff = differenceInDays(startOfDay(new Date()), startOfDay(date));
  if (diff >= 2 && diff <= 6) return format(date, 'EEEE');
  return format(date, 'MMM d, yyyy');
}

export function formatMessageTime(message) {
  const date = getMessageDate(message);
  if (!date) return '';
  return format(date, 'h:mm a');
}

export function buildMessageItems(messages) {
  const items = [];
  let lastDayKey = null;
  (messages ?? []).forEach((message, idx) => {
    const date = getMessageDate(message) ?? new Date();
    const dayKey = format(startOfDay(date), 'yyyy-MM-dd');
    if (dayKey !== lastDayKey) {
      items.push({
        type: 'divider',
        key: `divider-${dayKey}-${idx}`,
        label: formatRelativeDay(date),
      });
      lastDayKey = dayKey;
    }
    items.push({
      type: 'message',
      key: message.id ?? message.messageId ?? `msg-${idx}`,
      message,
    });
  });
  return items;
}
